<template>
  <div class="card">
    <img class="wordTop" src="../assets/card_word_1.png">
    <img class="wordCenter" src="../assets/card_word_2.png">
    <img src="../assets/btn_yq.png" alt="邀请好友点赞" class="btn" @click="getNum">
    <div class="share" v-show="display" @click="hide">
      <img src="../assets/share.png">
    </div>
  </div>
</template>

<script>
  module.exports = {
    data: function () {
      return {
        display: false
      }
    },
    ready: function () {
      this.share(true)
    },
    methods: {
      getNum: function () {
        const self = this

        if (self.isFirstClickBtn) {
          self.isFirstClickBtn = false
        } else {
          self.share(false)

          if (ydk.isYD) {
            self.display = false
          } else {
            self.display = true
          }
        }
      },
      share: function (sil) {
        const self = this
        const url = "http://shared.youdao.com/market/2018teacher/final/"
        //此处分享点赞页面
        const shareUrl = url + 'index.html?time=' + Math.random() + '/#!/share?userName=' + encodeURI(self.$route.query.userName) + '&mobile=' + self.$route.query.mobile;
        const shareImg = 'http://shared.youdao.com/market/2018teacher/image/share.png'
        ydk.share({
          silence: sil,
          shift: true,
          title: "我为老师送上了一份教师节的祝福",
          desc: "快来为我点赞吧",
          imgUrl: shareImg,
          link: shareUrl
        })
      },
      hide: function () {
        this.display = false;
      }
    }
  }
</script>

<style scoped>
  .card {
    width: 100%;
    height: 100%;
    background: url("../assets/p4.jpg") 0 0/100% 100% no-repeat;
  }

  .wordTop{
    display: block;
    width: 3.52rem;
    height: 0.38rem;
    margin: 15% auto 0;
  }

  .wordCenter{
    width: 5.42rem;
    height: 7rem;
    display: block;
    margin: 6% auto 0;
  }

  .btn {
    width: 46%;
    height: 5.3%;
    position: absolute;
    bottom: 15%;
    left: 50%;
    margin-left: -23%;
    -webkit-tap-highlight-color: transparent;
  }

  .share {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .share img {
    position: absolute;
    top: 8%;
    right: 5%;
    width: 2.29rem;
    height:2rem;
  }
  @media screen  and (max-height: 600px) {
    .wordTop{
      margin: 10% auto 0;
    }
    .btn{
      bottom: 14%;
    }
  }
  @media screen and (max-width: 360px) and (max-height: 540px) {
    .wordTop{
      margin: 10% auto 0;
    }
    .btn{
      bottom: 10%;
    }
  }

  @media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){
    .wordTop{
      margin: 10% auto 0;
    }
  }
  @media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){
    .wordTop{
      margin: 10% auto 0;
    }
  }
  @media screen and (min-height: 800px)  {
    .wordTop{
      margin: 30% auto 0;
    }
  }

</style>



// WEBPACK FOOTER //
// Card.vue?be227d86